import { grey } from "@faro-lotv/flat-ui";
import { Box } from "@mui/material";
import { type JSX } from "react";
import { AnnotationColor, annotationColorToCss } from "./annotation-colors";

/** @returns the color of an annotation as a dot, for the toolbar and the Style button of the phone sheet */
export function ColorDot({ color }: { color?: AnnotationColor }): JSX.Element {
  return (
    <Box
      sx={{
        width: 16,
        height: 16,
        borderRadius: "50%",
        border: `2px solid ${grey[0]}`,
        boxShadow: `0 0 0 1px ${grey[500]}`,
        backgroundColor: annotationColorToCss(color),
      }}
    />
  );
}
